<div [class.bl-disabled]="!field.enabled" [ngClass]="formatter">
  <label class="bl-label bl-font-weight--800 bl-font-size--14" [for]="field.id" [class.bl-required]="field.required">
    {{ field.label }}
    <button *ngIf="tooltip" type="button" aria-label="tooltip" class="bl-font-color--blue bl-margin-left--4">
      <i class="cu-info-circle" eaTooltip="{{ tooltip }}"></i>
      <span class="bl-screen-reader-only">{{ tooltip }}</span>
    </button>
  </label>

  <input
    [type]="inputType"
    [autocomplete]="inputAutocomplete"
    [attr.aria-describedby]="field.id + '-desc-container'"
    class="bl-form-input bl-input"
    [class.bl-disabled]="!field.enabled"
    [required]="field.required"
    #input
    [attr.inputmode]="field.inputMode"
    [cuFieldState]="field"
    [disabled]="!field.enabled"
    [id]="field.id"
    [maxlength]="field.fieldMaxLength"
    [attr.data-automation-id]="field.automationId"
    [placeholder]="field.config.placeholder || ''"
    [(ngModel)]="maskedValue"
    (blur)="doBlur()"
    (cut)="processMask()"
    (focus)="doFocus()"
    (input)="processMask()"
    (keyup)="processMask()"
    (keypress)="blockSpecialChar($event)"
    (mouseup)="processMask()"
    (paste)="processMask()"
    (selectionchange)="processMask()"
    (keydown.enter)="$event.target['blur']()"
  />
</div>
